import {
  Breadcrumbs,
  Typography,
  Link,
} from "@mui/material";

import { Link as RouterLink } from "react-router-dom";

export default function BreadcrumbsBar({
  page = "Dashboard",
}) {
  return (
    <Breadcrumbs sx={{ mb: 3 }} className="no-print">
      <Link
        component={RouterLink}
        underline="hover"
        color="inherit"
        to="/"
      >
        Home
      </Link>

      <Typography color="text.primary">
        {page}
      </Typography>
    </Breadcrumbs>
  );
}